import { Definition } from "../data/Definition";
import { ChartConfigManager } from "./charts/ChartConfigManager";
import { IFilter, IMeasure } from "../data/Query";

const currentVersion = "2";

type ConfigType = {
    definitionId: number,
    version: string,
    dimension: {
        item: any,
        bin: any
    },
    feature: string,
    measure: IMeasure | null,
    filters: IFilter[]
};

export class DwMapLayerConfigManager extends ChartConfigManager {
    private definition: Definition;

    constructor(definition: Definition) {
        super();

        this.definition = definition;
    }

    currentVersion(): string {
        return currentVersion;
    }

    isCurrentVersion(config: any): boolean {
        return config !== null && config.version !== undefined && config.version === currentVersion;
    }

    validate(config: any): boolean {
        return this.isCurrentVersion(config);
    }

    convert(config: any) {
        return this.isCurrentVersion(config) ? config : this.convertToCurrent(config);
    }

    convertToCurrent(config: any) {
        if (!config) {
            let newConfig = {} as ConfigType;
            newConfig.version = currentVersion;
            return newConfig;
        }

        return this.convertFromV1(config);
    }

    private convertFromV1(config: any): ConfigType {
        let newConfig = {} as ConfigType;
        newConfig.version = currentVersion;

        console.log('DW convertFromV1 > from', config);

        if (config == null) {
            return newConfig;
        }

        newConfig.definitionId = config.definitionId;
        
        newConfig.dimension = config.dimension;

        if (config.measure) {
            newConfig.measure = {
                source: {
                    item: config.measure.item,
                    sub: config.measure.value
                },
                aggregation: config.measure.agg
            }
        }

        // filters
        if (config.filters) {
            newConfig.filters = config.filters.map((filter: any) => {
                return {
                    source: {
                        item: filter.item,
                        sub: null
                    },
                    operation: filter.operation,
                    value: filter.value
                };
            });
        }

        console.log('convertFromV1 > to', newConfig);

        return newConfig;
    }
}
